define([
    ], function() {
    'use strict'

    /**
     *
     *
     * @private
     *
     * @exports encode
     */
    const encode = (str)=>{
        var lengthBytes = Module.lengthBytesUTF8(str) + 1
        var newStr = Module._malloc(lengthBytes)
        if(newStr){
            stringToUTF8Array(str, HEAP8, newStr, lengthBytes)
        }
        //Module.stringToUTF8(str, newStr, lengthBytes)
        return newStr
    }
    return encode
})
